import { render, staticRenderFns } from "./ErrorPermission.vue?vue&type=template&id=35ef6612&scoped=true"
import script from "./ErrorPermission.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPermission.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef6612",
  null
  
)

export default component.exports